"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcSalesPersonField = void 0;
var react_1 = __importDefault(require("react"));
var ac_ui_1 = require("@aperza/ac-ui");
var AcSalesPersonField = function (props) {
    var _a = props.salesPersons, salesPersons = _a === void 0 ? [] : _a, value = props.value;
    var shouldItemRender = function (salesPerson, _value) {
        var _a, _b, _c;
        return (((_a = salesPerson === null || salesPerson === void 0 ? void 0 : salesPerson.userName) === null || _a === void 0 ? void 0 : _a.includes(_value)) ||
            ((_b = salesPerson === null || salesPerson === void 0 ? void 0 : salesPerson.phoneticUserName) === null || _b === void 0 ? void 0 : _b.includes(_value)) ||
            ((_c = salesPerson === null || salesPerson === void 0 ? void 0 : salesPerson.mailAddress) === null || _c === void 0 ? void 0 : _c.includes(_value)));
    };
    return (react_1.default.createElement(ac_ui_1.AcAutocompleteField2, __assign({}, props, { value: value, items: salesPersons, shouldItemRender: shouldItemRender, getItemId: function (salesPerson) {
            if (salesPerson) {
                // TODO to resolve id type for salesPerson. It should be int.
                var id = salesPerson === null || salesPerson === void 0 ? void 0 : salesPerson.id;
                return parseInt(id, 10);
            }
            return undefined;
        }, getItemValue: function (salesPerson) { return salesPerson.userName; }, getItemSubtitle: function (salesPerson) { return salesPerson.mailAddress; }, getItemChipTooltip: function (salesPerson) { return salesPerson.userName + "\n" + salesPerson.mailAddress; } })));
};
exports.AcSalesPersonField = AcSalesPersonField;
exports.AcSalesPersonField.displayName = 'AcSalesPersonField';
//# sourceMappingURL=AcSalesPersonField.js.map